import { render, staticRenderFns } from "./WebhookAutomationForm.vue?vue&type=template&id=b028378a&scoped=true"
import script from "./WebhookAutomationForm.vue?vue&type=script&lang=js"
export * from "./WebhookAutomationForm.vue?vue&type=script&lang=js"
import style0 from "./WebhookAutomationForm.vue?vue&type=style&index=0&id=b028378a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b028378a",
  null
  
)

export default component.exports